export function GET_USER_LOGIN_DATA(data, locationfired) {
  const { tenantIdentifier, tenantId, username, domains } = data || {};
  window.dataLayer.push({
    event: 'get_user_data',
    tenant: tenantIdentifier,
    username,
    locationfired,
    tenantDetails: {
      tenantId,
      tenantIdentifier,
      username,
      domains,
      env: process.env.REACT_APP_ENV,
    },
  });
}

// push events with certain event codes to analyze on GTM and Google Analytics
export function GTM_TRACK_EVENT(EVENT) {
  window.dataLayer.push({
    event: 'Custom Trigger',
    triggername: EVENT,
  });
}
